<template>
  <v-container fluid class="customer-classes">
    <div>
      <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
        <v-progress-circular indeterminate></v-progress-circular>
      </v-row>
      <div dense class="mt-9" v-else>
        <div v-if="needsMatch">
          <v-row dense class="mt-9">
            <v-row dense>
              <v-col>
                <v-card
                  elevation="1"
                  style="
                    border-radius: 10px;
                    position: relative;
                    overflow: visible;
                  "
                >
                  <v-card-text>
                    <v-row dense style="padding: 2vh">
                      <v-col cols="12" md="10">
                        <div
                          class="d-flex align-start justify-start flex-column"
                        >
                          <span class="header mb-4">Minhas turmas</span>
                          <span>{{ subText }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="2" class="image-col"> </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-row>

          <v-row dense class="mt-8" v-if="matchingTeachers.length">
            <v-col cols="12">
              <div class="section-heading">
                Professores com horário compatível
              </div>
              <div class="section-subtitle">
                Escolha um professor para enviar sua solicitação com base nos
                horários disponíveis para você.
              </div>
            </v-col>
            <v-col
              v-for="(teacher, subIndex) in matchingTeachers"
              :key="`teacher-${subIndex}`"
              cols="12"
              md="4"
              class="d-flex"
            >
              <MatchedPartnerCard
                :item="teacher"
                :limit="limit"
                @requestJoin="sendRequestToTeacher"
              />
            </v-col>
          </v-row>

          <v-row dense class="mt-8" v-if="availableGroups.length">
            <v-col cols="12">
              <div class="section-heading">
                Turmas abertas para o seu perfil
              </div>
              <div class="section-subtitle">
                Essas turmas já estão ativas, têm o formato escolhido por você e
                ainda possuem vaga disponível.
              </div>
            </v-col>
            <v-col
              v-for="(group, index) in availableGroups"
              :key="`group-${index}`"
              cols="12"
              md="6"
              class="d-flex"
            >
              <MatchedGroupCard
                :item="group"
                @requestJoin="sendRequestToGroup"
              />
            </v-col>
          </v-row>

          <v-row
            dense
            class="mt-10"
            v-if="!matchingTeachers.length && !availableGroups.length"
          >
            <v-col
              cols="12"
              class="d-flex align-center justify-center flex-column text-center"
            >
              <span class="text-h4 bolder--text">
                Nenhuma opção disponível agora
              </span>
              <small class="text-h6 mt-3">
                Assim que encontrarmos um professor ou uma turma compatível com
                seu perfil, ela aparecerá aqui.
              </small>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row dense class="mt-9">
            <v-col cols="12">
              <v-card
                elevation="1"
                style="
                  border-radius: 10px;
                  position: relative;
                  overflow: visible;
                "
              >
                <v-card-text>
                  <v-row dense style="padding: 2vh">
                    <v-col cols="12" md="10">
                      <div class="d-flex align-start justify-start flex-column">
                        <span class="header mb-4">Minhas turmas</span>
                        <span
                          >Seja bem-vindo, verifique as turmas nas quais você
                          participa 🥳</span
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" md="2" class="image-col"> </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense class="mt-6">
            <v-col
              v-for="(item, index) in data"
              :key="index"
              cols="12"
              class="d-flex"
            >
              <ClassView :item="item" />
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import customerApi from "@/shared/pitchCustomerApi";
import ClassView from "@/components/connect/customer/ClassView.vue";
import MatchedPartnerCard from "@/components/connect/partner/MatchedPartnerCard.vue";
import MatchedGroupCard from "@/components/connect/customer/MatchedGroupCard.vue";

export default {
  name: "CustomerClasses",
  components: { MatchedPartnerCard, MatchedGroupCard, ClassView },
  async created() {
    await this.loadData();
  },
  data() {
    return {
      limit: 0,
      needsMatch: false,
      count: 0,
      data: [],
      loading: true,
      subText:
        "Você ainda não faz parte de uma turma. Veja abaixo professores com horários compatíveis e turmas que combinam com o formato escolhido no seu cadastro.",
      matchingTeachers: [],
      availableGroups: [],
    };
  },
  methods: {
    async loadData() {
      this.loading = true;

      await customerApi
        .groups()
        .then(async (groups) => {
          if (groups.data.count === 0) {
            this.needsMatch = true;
            await this.loadMatchOptions();
          } else {
            this.data = groups.data.data.data;
            this.count = groups.data.count;
          }
          this.loading = false;
        })
        .catch(() => {
          this.$root.$emit("display-alert", {
            text: "Nao foi possivel carregar suas turmas no momento.",
            type: 1,
          });
          this.loading = false;
        });
    },
    async loadMatchOptions() {
      await customerApi
        .doAMatch()
        .then((res) => {
          this.matchingTeachers = Array.isArray(res.data.teachers)
            ? res.data.teachers
            : [];
          this.availableGroups = Array.isArray(res.data.groups)
            ? res.data.groups
            : [];
          this.limit = res.data.limit;
        })
        .catch(() => {
          this.matchingTeachers = [];
          this.availableGroups = [];
          this.$root.$emit("display-alert", {
            text: "Nao foi possivel carregar as opcoes de match agora.",
            type: 1,
          });
        });
    },
    async sendRequestToTeacher(item) {
      await customerApi
        .requestJoin({ partnerId: item.id, hours: item.hours })
        .then((res) => {
          this.$root.$emit("display-alert", {
            text: res.data.message + " 😊",
            type: 0,
          });
        })
        .catch((err) => {
          if (err.response.data.statusCode === 400) {
            this.$root.$emit("display-alert", {
              text: err.response.data.message,
              type: 1,
            });
          } else
            this.$root.$emit("display-alert", {
              text: "Algo deu errado durante a solicitação para juntar-se a turma 🥺",
              type: 1,
            });
        });
    },
    async sendRequestToGroup(item) {
      if (
        !window.confirm(
          `Confirmar envio de solicitação para entrar na turma ${item.cod}?`
        )
      ) {
        return;
      }

      await customerApi
        .requestJoin({ classId: item.id })
        .then((res) => {
          this.$root.$emit("display-alert", {
            text: res.data.message + " 😊",
            type: 0,
          });
          this.loadData();
        })
        .catch((err) => {
          this.$root.$emit("display-alert", {
            text:
              err?.response?.data?.message ||
              "Algo deu errado durante a solicitação para entrar na turma 🥺",
            type: 1,
          });
        });
    },
  },
};
</script>

<style lang="css" scoped>
.customer-classes {
  width: 100%;
}

.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}

.section-heading {
  font-family: "Poppins", "Sans-serif";
  font-size: 1.45rem;
  font-weight: 700;
  color: #1f2430;
}

.section-subtitle {
  margin-top: 0.5rem;
  color: rgba(31, 36, 48, 0.7);
}
</style>
